import React from 'react';

export default function Number() {
  return (
    <React.Fragment>
      It's a Number!
    </React.Fragment>
  );
}
